const INITIAL_STATE = {
  contactId: 0,
  codeToken: ''
}

export default function tokenReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_CONTACT_ID':
      return {
        ...state,
        contactId: action.contactId,
      }
    case 'SET_CODE_TOKEN':
      return {
        ...state,
        codeToken: action.codeToken,
      }
    default:
      return state;
  }
}
